import React, { useState } from 'react'
import { Button, KIND } from "baseui/button";
import { json, useNavigate } from "react-router-dom";
import { getData } from '../utils/data';
import ArrowRight from 'baseui/icon/arrow-right';
import { Card } from "baseui/card";
import { UserContext } from '../App';
import InputBox from '../components/InputBox';
import HeadingSection from '../components/Heading';
import logo from '../assets/orcalogo.png';
import { baseUrl, getHeader } from '../utils/consts';
import { Notification, KIND as NKIND } from "baseui/notification";
import { useSnackbar } from 'baseui/snackbar';

const SignUp = () => {
    let navigate = useNavigate();
    const { enqueue } = useSnackbar();
    let { name, setValue, orcaAPIKey } = React.useContext(UserContext);
    const [isLoading, setIsLoading] = useState(false);

    let createMerchantAccount = () => {
        if (!name) return

        setIsLoading(true)
        fetchCreateMerchantAccount();
    }

    const setMessage = (message, bgColor) => {
        enqueue({
            message: message,
            overrides: {
                Root: { style: { width: 'auto', backgroundColor: bgColor } },
            }
        })
    }

    let fetchCreateMerchantAccount = () => {
        let merchantData = getData(name)

        localStorage.setItem("cache", JSON.stringify({
            name,
            orcaAPIKey: "",
            uid: "",
            selectedPg: "",
            selectedPgs: []
        }))
        setValue("uid", "")
        setValue("orcaAPIKey", "")
        setValue("selectedPg", "")
        setValue("selectedPgs", [])

        fetch(`${baseUrl}/accounts`, {
            method: 'POST',
            headers: getHeader('test_admin'),
            body: merchantData
        })
            .then((res) => {
                if (res.status === 200) {
                    res.json().then(val => {
                        setValue("uid", val.merchant_id)
                        setValue("orcaAPIKey", val.api_key)
                        setMessage('Account Created Successfully', "green")
                    })
                } else {
                    res.text().then(val =>
                        console.log("Network Error:-", JSON.parse(val).error)
                    )
                    setMessage("Cound't Get the Response", "red")
                }
                setIsLoading(false)
            }).catch(err => {
                console.log("ERROR:- ", err.message)
                setMessage("There was an error!", "red")
                setIsLoading(false)
            }
            );
    }


    return (
        <>
            <div style={{ height: "500px" }} className='w-full max-w-md  mx-auto' >
                <Card>
                    <div className='p-5' >
                        <HeadingSection level={6} title={"Welcome To"} />
                        <div className='-mt-4 ml-28 mb-5 overflow-hidden' style={{ height: "30px" }} ><img className='-mt-5' src={logo} width="150px" alt="" /></div>
                        <InputBox label={"Name"} value={name} onChange={val => setValue("name", val)} placeholder={"Enter your name"} />
                        <div className='mt-5' >
                            <Button style={{ width: "100%" }} kind={KIND.secondary} onClick={createMerchantAccount} disabled={!name} isLoading={isLoading}>Submit</Button>
                        </div>
                        <div className={`w-full h-full mt-8 ${!orcaAPIKey ? "hidden" : "block"}`}>
                            <InputBox label={"Orca API Key"} value={orcaAPIKey} placeholder={"Orca API Key"} readOnly={true} />
                            <Notification kind={NKIND.warning} overrides={{
                                Body: { style: { width: 'auto', marginLeft: "0", marginRight: "0" } },
                            }}>
                                {() => (<><div className='font-medium mb-1' >
                                    Instructions:
                                </div>
                                    <div className='text-sm mb-4 ml-3'>
                                        <ul className='list-disc' >
                                            <li>Use this new API key to test ORCA APIs on our sandbox environment.
                                            </li>
                                            <li>Copy and securely store this new API key for future reference
                                            </li>
                                        </ul>
                                    </div></>)}
                            </Notification>
                            <Button className='mt-10' style={{ width: "100%" }} onClick={() => navigate("/account-retrive")} endEnhancer={() => <ArrowRight size={24} />}  >Next</Button>
                        </div>
                    </div>
                </Card>
            </div >
            <div className='absolute top-0 w-full flex justify-center pt-7' >
                <Notification kind={NKIND.warning} overrides={{
                    Body: { style: { width: 'auto' } },
                }}>
                    {() => "This dashboard is only prototype of the Orca Dashboard. It is distributed only for Juspay - Internal Closed User Group users."}
                </Notification>
            </div>
        </>
    )
}

export default SignUp